if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.content = this.querySelector('.product-media-modal__content');
        this.counter = this.querySelector('[data-modal-counter]');
        this.prevButton = this.querySelector('[data-modal-nav="prev"]');
        this.nextButton = this.querySelector('[data-modal-nav="next"]');
        this.touchStartX = 0;
        this.touchStartY = 0;

        this.onNavClick = this.onNavClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onTouchStart = this.onTouchStart.bind(this);
        this.onTouchEnd = this.onTouchEnd.bind(this);

        this.prevButton?.addEventListener('click', this.onNavClick);
        this.nextButton?.addEventListener('click', this.onNavClick);
        this.prevButton?.addEventListener('pointerup', (event) => event.stopPropagation());
        this.nextButton?.addEventListener('pointerup', (event) => event.stopPropagation());
      }

      hide() {
        this.removeEventListener('keydown', this.onKeydown);
        this.content?.removeEventListener('touchstart', this.onTouchStart);
        this.content?.removeEventListener('touchend', this.onTouchEnd);
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.addEventListener('keydown', this.onKeydown);
        this.content?.addEventListener('touchstart', this.onTouchStart, { passive: true });
        this.content?.addEventListener('touchend', this.onTouchEnd);
        this.showActiveMedia();
      }

      getMediaItems() {
        return Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]')).filter((item) => {
          if (!item.classList.contains('product__media-item--variant')) return true;
          return item.matches(':first-child');
        });
      }

      showActiveMedia(mediaId = this.openedBy?.getAttribute('data-media-id')) {
        const items = this.getMediaItems();
        const activeMedia =
          items.find((item) => item.getAttribute('data-media-id') === mediaId) || items[0];

        if (!activeMedia) return;

        this.querySelectorAll('.product-media-modal__content > [data-media-id]').forEach((element) => {
          element.classList.toggle('active', element === activeMedia);
        });

        const container = this.querySelector('[role="document"]');
        if (container) {
          container.scrollTop = 0;
          container.scrollLeft = 0;
        }

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();

        this.updateNav(items);
      }

      updateNav(items = this.getMediaItems()) {
        const showNav = items.length > 1;
        const currentIndex = Math.max(
          items.findIndex((item) => item.classList.contains('active')),
          0
        );
        this.prevButton?.classList.toggle('hidden', !showNav);
        this.nextButton?.classList.toggle('hidden', !showNav);
        if (this.counter) {
          this.counter.textContent = `${currentIndex + 1}/${items.length}`;
          this.counter.toggleAttribute('hidden', !showNav);
        }
      }

      step(delta) {
        const items = this.getMediaItems();
        if (items.length < 2) return;

        const currentIndex = items.findIndex((item) => item.classList.contains('active'));
        const nextIndex = (Math.max(currentIndex, 0) + delta + items.length) % items.length;
        this.showActiveMedia(items[nextIndex].getAttribute('data-media-id'));
      }

      onNavClick(event) {
        event.preventDefault();
        event.stopPropagation();
        this.step(event.currentTarget.getAttribute('data-modal-nav') === 'next' ? 1 : -1);
      }

      onKeydown(event) {
        if (event.key === 'ArrowRight') this.step(1);
        if (event.key === 'ArrowLeft') this.step(-1);
      }

      onTouchStart(event) {
        const touch = event.changedTouches[0];
        this.touchStartX = touch.clientX;
        this.touchStartY = touch.clientY;
      }

      onTouchEnd(event) {
        const touch = event.changedTouches[0];
        const deltaX = touch.clientX - this.touchStartX;
        const deltaY = touch.clientY - this.touchStartY;
        if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY)) return;
        this.step(deltaX < 0 ? 1 : -1);
      }
    }
  );
}
